// complexity 12
/* eslint-disable complexity */
import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router';

import { usePermissionGroups, usePermissions } from '@sbu/hooks.permissions';

import { useAppInfoQuery } from 'app/AppInfoQuery';
import { PageLoader } from 'shared/components/elements/Loader';

type GuardedRouteProps = {
  component?: any;
  render?: any;
  allowedPermissions?: Array<string>;
  aggregateAllowedPermissions?: string[][];
  allowFederated?: boolean;
  redirectTo?: string;
} & RouteProps;

export const GuardedRoute = ({
  component: Component,
  allowedPermissions = [],
  aggregateAllowedPermissions = [],
  allowFederated = false,
  redirectTo,
  render,
  ...rest
}: GuardedRouteProps) => {
  const { data, loading } = useAppInfoQuery();
  const { hasAny: hasPermissions, loading: permissionsLoading } =
    usePermissions(allowedPermissions);
  const {
    hasAny: hasAnyAggregatePermissions,
    loading: aggregatePermissionsLoading,
  } = usePermissionGroups(aggregateAllowedPermissions);
  const dataLoading =
    (permissionsLoading || loading || aggregatePermissionsLoading) && !data;
  return (
    <Route
      {...rest}
      render={(props) => {
        if (dataLoading) {
          return <PageLoader />;
        }

        if (!dataLoading) {
          const { isFederatedCluster } = data || { currentUser: {} };

          if (isFederatedCluster && !!allowFederated === false && redirectTo) {
            return <Redirect to={redirectTo} />;
          }

          if (
            (allowedPermissions.length === 0 || hasPermissions) &&
            (aggregateAllowedPermissions.length === 0 ||
              hasAnyAggregatePermissions)
          ) {
            if (Component) {
              return <Component {...props} />;
            } else if (render) {
              return render(props);
            }
          }
        }

        return null;
      }}
    />
  );
};
